import { put, takeEvery } from 'redux-saga/effects';
import {
  startFetchDocumentUserTemplate,
  fetchTemplateSuccess,
  fetchTemplateFailure,
} from 'redux/template/actions';
import { Notify } from '@flexisaf/flexibull2';
import request from 'utils/request';
import urls from 'utils/config';
import TemplatesActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { TEMPLATE_BASE_URL } = urls || {};

export function* fetchUserDocumentTemplates({ payload }) {
  const url = `${TEMPLATE_BASE_URL}/templates?type=document&index=${
    +payload.currentPage || 0
  }&size=${+payload.pageSize || 10}${
    payload.searchPattern ? `&name=${payload.searchPattern}` : ''
  }`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(
      fetchTemplateSuccess({
        template: response.raw,
        type: 'document',
        explicitType: 'user',
      })
    );
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Templates: ${response.message}`);
    yield put(fetchTemplateFailure(response.message));
  }
}

export function* getDocumentUserTemplates() {
  yield takeEvery(
    TemplatesActionTypes.START_FETCH_DOCUMENT_USER_TEMPLATES,
    fetchUserDocumentTemplates
  );
}

export function* fetchSystemDocumentTemplates({ payload }) {
  const url = `${TEMPLATE_BASE_URL}/admin?type=document&index=${
    +payload.currentPage || 0
  }&size=${+payload.pageSize || 10}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(
      fetchTemplateSuccess({
        template: response.raw,
        type: 'document',
        explicitType: 'system',
      })
    );
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Templates: ${response.message}`);
    yield put(fetchTemplateFailure(response.message));
  }
}

export function* getDocumentSystemTemplates() {
  yield takeEvery(
    TemplatesActionTypes.START_FETCH_DOCUMENT_SYSTEM_TEMPLATES,
    fetchSystemDocumentTemplates
  );
}

export function* updateUserDocumentTemplates({ payload }) {
  const { id, active, name, cb } = payload;
  const url = `${TEMPLATE_BASE_URL}/templates/${id}`;

  const response = yield request({
    method: 'patch',
    data: {
      active,
      name
    },
    url,
  });
  if (response.success) {
    yield put(
      startFetchDocumentUserTemplate({
        currentPage: 0,
        pageSize: 10,
      })
    );
    Notify('Template updated successfully', {
      position: 'top-right',
      status: 'success',
    });
    if (cb && typeof cb === 'function') {
      cb();
    }
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Update Templates: ${response.message}`);
    yield put(fetchTemplateFailure(response.message));
  }
}

export function* onUpdateDocumentUserTemplates() {
  yield takeEvery(
    TemplatesActionTypes.UPDATE_DOCUMENT_TEMPLATE_START,
    updateUserDocumentTemplates
  );
}
